import React from 'react'

const SvgCalendarFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M6 4h1V3c-.002-.667.33-1 1-1 .67 0 1.004.333 1.004 1v1H15V2.941c0-.627.333-.941 1-.941s1 .314 1 .941V4h1c1.333 0 2 .667 2 2v14c0 1.333-.667 2-2 2H6c-1.333 0-2-.667-2-2V6.004C4 4.668 4.667 4 6 4zM4 8v2h16V8H4zm5 7h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1zm5 0h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1zm-5 4h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1zm5 0h1c.667 0 1-.333 1-1s-.333-1-1-1h-.998c-.667-.001-1.001.332-1.002 1 0 .668.333 1.001 1 1z' />
  </svg>
)

export default SvgCalendarFilled
